const User = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.3999C10.5641 3.3999 9.40002 4.56396 9.40002 5.9999C9.40002 7.43584 10.5641 8.5999 12 8.5999C13.436 8.5999 14.6 7.43584 14.6 5.9999C14.6 4.56396 13.436 3.3999 12 3.3999ZM7.40002 5.9999C7.40002 3.45939 9.45951 1.3999 12 1.3999C14.5405 1.3999 16.6 3.45939 16.6 5.9999C16.6 8.54041 14.5405 10.5999 12 10.5999C9.45951 10.5999 7.40002 8.54041 7.40002 5.9999ZM4.16983 14.8883C5.99086 13.4753 8.63038 12.6761 12 12.6761C15.3697 12.6761 18.0092 13.4753 19.8302 14.8883C21.6734 16.3186 22.6 18.3217 22.6 20.5123C22.6 21.5635 21.8106 22.5999 20.6212 22.5999H3.37885C2.18948 22.5999 1.40002 21.5635 1.40002 20.5123C1.40002 18.3217 2.32664 16.3186 4.16983 14.8883ZM5.39593 16.4684C4.05055 17.5124 3.40002 18.9274 3.40002 20.5123C3.40002 20.5547 3.4114 20.5836 3.42108 20.5999H20.579C20.5886 20.5836 20.6 20.5547 20.6 20.5123C20.6 18.9274 19.9495 17.5124 18.6041 16.4684C17.2366 15.4073 15.0761 14.6761 12 14.6761C8.92395 14.6761 6.76347 15.4073 5.39593 16.4684Z"
        fill={color}
      />
    </svg>
  );
  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default User;
